import { directSalesFlowPages, DirectSalesFlowSlug } from "../constants";
import { useFlowNavigation } from "../../signupFlow/hooks/useFlowNavigation";

export function useDirectSalesSignupFlowNavigation(slug: DirectSalesFlowSlug) {
  return useFlowNavigation(slug, directSalesFlowPages);
}
